import { styled } from "styled-components";
import { Colors, Header, Paragraph } from "../constants";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  flex: 1;
  @media (max-width: 800px) {
    display: ${(props) => (props.tab === "bio" ? `flex` : `none`)};
  }
`;

const BioSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const Item = styled(Paragraph)`
  text-transform: capitalize;
`;

const CharacterBio = ({ character, currentTab }) => {
  return (
    <Wrapper tab={currentTab}>
      <BioSection>
        <Header>Name</Header>
        <Paragraph>{character.name}</Paragraph>
      </BioSection>
      <BioSection>
        <Header>Who are you?</Header>
        <Paragraph>{character.description}</Paragraph>
      </BioSection>
      <BioSection>
        <Header>Your Gear</Header>
        {character.items.map((item, index) => (
          <Item key={index}>
            {item.name} ({item.stat}{" "}
            {item.bonus > 0 ? "+" + item.bonus : item.bonus})
          </Item>
        ))}
      </BioSection>
    </Wrapper>
  );
};

export default CharacterBio;
